import { QuestInstance } from "@joonapp/web-shared"
import { useQuery } from "@tanstack/react-query"
import { Dayjs } from "dayjs"

import { getAssignedQuests } from "./api"
import { QueryKey } from "../../types/queries"
import { useFamilyQuery } from "../families/queries"

export const useAssignedQuestsQuery = (date: Dayjs) => {
  const { data: family } = useFamilyQuery()
  const familyUserIds: number[] =
    family?.profiles?.map((profile) => profile.user.id) || []
  const selectedDate = date?.format("YYYY-MM-DD") || ""

  return useQuery<QuestInstance[]>({
    queryKey: [QueryKey.QUESTS, selectedDate, familyUserIds],
    queryFn: () => getAssignedQuests(selectedDate, familyUserIds),
    enabled: !!selectedDate && familyUserIds.length > 0,
  })
}
